function getTransmissionDetails(state) {
	return state.outboundTransmission;
}
export default {  getTransmissionDetails };